import { contextFactory } from '@frontend/design-system';
import { LegalTypes } from '../../../types';

export interface LegalContextProps {
  locationId: string;
  documentType: LegalTypes.DocumentType;
}

export const [LegalContext, useLegalContext] = contextFactory<LegalContextProps>();
